import { useApp } from '@libs/hooks';
import { ConditionalRender, copyTextToClipboard } from '@libs/utils';
import React, { useEffect, useRef } from 'react';
import { TCardBalanceDataMessages } from '../../../../types/data';
import { ButtonRow } from '../../../Buttons/ButtonRow';
import { PopupComponent } from '../../../UI/Popup/PopupComponent';
import { ButtonRowCopy } from '../ButtonRowCopy';
import { formatCardNumber } from '../utils/utils';

type TCardDetails = {
    pan?: string;
    expirationDate?: string;
    cardholderName?: string;
    cvv?: string;
    messages: TCardBalanceDataMessages;
};

export const CardDetails = ({ messages, pan, expirationDate, cardholderName, cvv }: TCardDetails) => {
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const copyText = (textToClipboard: string, description: string) => copyTextToClipboard(textToClipboard, `${description} ${messages.copiedText}`);

    const { setPopup } = useApp();

    useEffect(() => {
        timeoutRef.current = setTimeout(() => setPopup(null), 60 * 1000);

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [setPopup]);

    copyText(pan ?? '', messages.cardNumberTitle);

    return (
        <PopupComponent
            withoutSeparator
            internalContent={
                <>
                    <ConditionalRender condition={!!pan}>
                        <ButtonRowCopy
                            title={messages.cardNumberTitle}
                            text={formatCardNumber(pan)}
                            onClick={() => copyTextToClipboard(pan ?? '', `${messages.cardNumberTitle} ${messages.copiedText}`)}
                        />
                    </ConditionalRender>
                    <ConditionalRender condition={!!expirationDate}>
                        <ButtonRowCopy title={messages.expirationDateTitle} text={expirationDate} onClick={copyText} />
                    </ConditionalRender>
                    <ConditionalRender condition={!!cardholderName}>
                        <ButtonRowCopy title={messages.cardholderNameTitle} text={cardholderName} onClick={copyText} />
                    </ConditionalRender>
                    <ConditionalRender condition={!!cvv}>
                        <ButtonRowCopy title={messages.cvvTitle} text={cvv} onClick={copyText} />
                    </ConditionalRender>
                </>
            }
            externalContent={[
                <ButtonRow
                    key={'hideDetailsBtn'}
                    isWidget={false}
                    isHide={false}
                    disabled={false}
                    as={'button'}
                    handleClick={() => setPopup(null)}
                    label={messages.hideDetailsBtn}
                    iconName={'ic_eye_crossed'}
                />,
            ]}
        />
    );
};
